
export class WorkingHoursValidationDetailSummary {

  constructor(
    public hash?: string,
    public userSubactivityHash?: string,
    public userSubactivityName?: string,
    public manufacturingOrderHash?: string,
    public manufacturingOrderCode?: string,
    public manufacturingOrderProject?: number,
    public manufacturingOrderProjectNumber?: string
  ) {}

  get isCompleted() {
    return this.manufacturingOrderHash !== null && this.userSubactivityHash !== null;
  }

  clone() {
    return new WorkingHoursValidationDetailSummary(
      this.hash,
      this.userSubactivityHash,
      this.userSubactivityName,
      this.manufacturingOrderHash,
      this.manufacturingOrderCode,
      this.manufacturingOrderProject,
      this.manufacturingOrderProjectNumber
    );
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/working-hours-validation-detail-summary.ts